/* eslint-disable */

<template>
    <BaseDialog
        :max_width="`80%`"
        :dialog="dialog"
        v-on:close_dialog="closeDialog">
        <template v-slot:title>
            <span v-if="o_idx!=-1">{{c_contact.name}} - MODIFICA</span>
            <span v-else>NUOVO CONTATTO</span>
        </template>
        <v-form ref="contact_form" v-model="valid">
            <div class="d-flex">
                <v-text-field dense outlined
                    v-model="c_contact.name"
                    label="nome e cognome*"
                    :rules="[rules.nameRules, rules.mandatory]"
                >
                </v-text-field>   
                <v-text-field dense outlined
                    label="email*"
                    class="ml-2"
                    v-model="c_contact.email"
                    :rules="[rules.emailRules, rules.mandatory]"
                ></v-text-field>
                <v-text-field dense outlined
                    label="telefono*"
                    class="ml-2"
                    v-model="c_contact.phone"
                    :rules="[rules.nameRules, rules.mandatory]"
                ></v-text-field>
            </div>
        </v-form>
        <template v-slot:action>
            <div class="d-flex align-center justify-center my-4">
                <v-btn color="primary" class="ma-2" @click.stop="saveContact" :disabled="!valid">Salva</v-btn>
                <v-btn color="action" class="ma-2" @click.stop="closeDialog">annulla</v-btn>
            </div>
        </template>
</BaseDialog>
</template>

<script>
// import _ from 'lodash'
import {getModel} from '../../utils/model'
import BaseDialog from '../../components/dialogs/BaseDialog'
import {f_rules} from '../../utils/commonUtils'
export default {
    components: {BaseDialog},
    props: {
    },
    data() {
        return {
            o_contact: null,
            o_idx: -1,
            c_contact: {},
            dialog: false,
            rules: f_rules,
            valid: false
        }
    },
    methods: {
        openDialog(contact, idx){
            this.o_idx = idx
            if (contact) {
                this.o_contact = contact
                this.c_contact = _.cloneDeep(contact)
            } else {
                let Contact = getModel("Contact");
                this.c_contact = Contact({id: new Date().getTime().toString()})
            }
            console.log(this.o_contact, this.o_idx)
            this.dialog = true;
            //this.$refs.contact_form.resetValidation()
        },
        closeDialog() {
            this.$refs.contact_form.reset()
            this.dialog = false;
        },
        saveContact() {
            this.$emit('contact_update', this.c_contact, this.o_idx)
        }
    }
}
</script>

<style>

</style>
